import {
  BreadcrumbItem,
  MarkdownFile
} from "@life-without-barriers/react-components"

import ContentLayout from "../../components/our-approach/layouts/ContentLayout"
import { IGatsbyImageData } from "gatsby-plugin-image"
import React from "react"
import { Site } from "@life-without-barriers/gatsby-common"
import { graphql } from "gatsby"

interface Frontmatter {
  title: string
  metaTitle: string
  metaDescription: string
  intro?: string
  contentTitle?: string
  contactUsComment?: string
  contactUsEmail?: string
}

interface TemplateMarkdown {
  frontmatter: Frontmatter
  html: string
  fields: {
    slug: string
  }
}

export interface MarkdownTemplateData {
  currentPage: TemplateMarkdown
  site: Site
  ogImage: IGatsbyImageData
}

export interface MarkdownTemplateProps {
  location: { pathname: string }
  data: MarkdownTemplateData
  breadcrumbs?: BreadcrumbItem[]
  afterContent?: React.ReactElement
  footnoteContent?: React.ReactElement
  ogImage?: IGatsbyImageData
}

const MarkdownTemplate = (props: MarkdownTemplateProps) => {
  const pageData = props.data.currentPage
  const { frontmatter, html } = pageData

  return (
    <ContentLayout
      location={props.location}
      site={props.data.site}
      ogImage={props.ogImage || props.data.ogImage}
      contentProps={frontmatter}
      afterContent={props.afterContent}
      footnoteContent={props.footnoteContent}
      breadcrumbs={
        props.breadcrumbs || [
          {
            to: "/our-approach",
            text: "Our approach",
            title: "Return to main page"
          }
        ]
      }
    >
      <MarkdownFile
        className="page markdown-file copy"
        dangerouslySetInnerHTML={{ __html: html }}
      />
    </ContentLayout>
  )
}

// moved to contenttypes
// export const ContentMarkdownQueryFragment = graphql`
//   fragment ContentMarkdownQueryFragment on Query {
//     currentPage: markdownRemark(fields: { slug: { eq: $slug } }) {
//       html
//       frontmatter {
//         title
//         contentTitle
//         intro
//         metaTitle
//         metaDescription
//         contactUsEmail
//         contactUsComment
//         resources {
//           name
//           reference {
//             publicURL
//           }
//         }
//         videoSection {
//           youTubeVideoId
//           title
//           text
//         }
//       }
//       fields {
//         slug
//       }
//     }
//     ogImage: file(relativePath: { regex: "/img-index-banner.jpg/" }) {
//       childImageSharp {
//         gatsbyImageData(width: 1200, quality: 90)
//       }
//     }
//     site {
//       siteMetadata {
//         title
//       }
//     }
//   }
// `

export const query = graphql`
  query ($slug: String) {
    ...ContentMarkdownQueryFragment
  }
`

export default MarkdownTemplate
